import { WritableStore } from "./WritableStore";
export class FormInstance {
    constructor(eventsChannel, formMembersFactory, id, formId, sectionInstances, isFinished, _dateCreated, _dateCompleted) {
        this.eventsChannel = eventsChannel;
        this.formMembersFactory = formMembersFactory;
        this.id = id;
        this.formId = formId;
        this._dateCreated = _dateCreated;
        this._dateCompleted = _dateCompleted;
        this.membersMap = new Map();
        this._isSigned = new WritableStore(false);
        this._isFullSigned = new WritableStore(false);
        this._isFinished = new WritableStore(false);
        this._members = new WritableStore([]);
        this.isSignedReadable = this._isSigned.getReadable();
        this.isFullSignedReadable = this._isFullSigned.getReadable();
        this.isFinishedReadable = this._isFinished.getReadable();
        this.membersReadable = this._members.getReadable();
        this._isFinished.set(isFinished);
        this.sections = new Map(sectionInstances.map(sectionInstance => [sectionInstance.sectionId, sectionInstance]));
        eventsChannel.on('member_add', event => this.onMemberAdd(event));
        eventsChannel.on('member_remove', event => this.onMemberRemove(event));
        eventsChannel.on('unsigned_all', () => this.onUnsignedAll());
    }
    // get persisted(): boolean {
    //     return this._persisted;
    // }
    get isSigned() {
        return this._isSigned.value;
    }
    get isFullSigned() {
        return this._isFullSigned.value;
    }
    get isFinished() {
        return this._isFinished.value;
    }
    get members() {
        return [...this.membersMap.values()].map(({ member }) => member);
    }
    get dateCreated() {
        return new Date(this._dateCreated.getTime());
    }
    get dateCompleted() {
        if (!this._dateCompleted) {
            return null;
        }
        return new Date(this._dateCompleted.getTime());
    }
    destroy() {
        for (const member of this.members) {
            member.destroy();
        }
        this.eventsChannel.destroy();
    }
    setFinished(dateCompleted) {
        if (this.isFinished) {
            return;
        }
        this._dateCompleted = dateCompleted;
        this._isFinished.set(true);
    }
    hasOwner(userId) {
        if (!this.hasMember(userId)) {
            return false;
        }
        const { member } = this.membersMap.get(userId);
        return member.isOwner;
    }
    hasMember(userId) {
        return this.membersMap.has(userId);
    }
    hasSign(userId) {
        if (!this.hasMember(userId)) {
            return false;
        }
        const { member } = this.membersMap.get(userId);
        return member.isSigned;
    }
    getMember(userId) {
        if (!this.hasMember(userId)) {
            return null;
        }
        const { member } = this.membersMap.get(userId);
        return member;
    }
    addMember(member) {
        if (this.hasMember(member.userId)) {
            return;
        }
        const memberItem = { member, subscriptions: [] };
        this.membersMap.set(member.userId, memberItem);
        this._members.set(this.members);
        memberItem.subscriptions.push(member.isSignedReadable.subscribe(() => this.updateSignStatus()));
        // if (this._persisted) {
        //     await this.instancesService.addMember(this.id, member.userId);
        // }
    }
    quitMember(userId) {
        if (!this.hasMember(userId)) {
            return;
        }
        const { member, subscriptions } = this.membersMap.get(userId);
        if (member.isOwner) {
            throw new Error('No se puede eliminar al propietario de la lista de miembros del fomulario.');
        }
        subscriptions.forEach(unsubscribe => unsubscribe());
        this.membersMap.delete(userId);
        this._members.set(this.members);
        this.updateSignStatus();
        // if (this._persisted) {
        //     await this.instancesService.quitMember(this.id, member.userId);
        // }
    }
    reloadMembers(members) {
        for (const member of this.members) {
            const m = members.find(mb => mb.userId.valueOf() == member.userId.valueOf());
            if (m) {
                member.buddyId = m.buddyId;
            }
        }
    }
    // async persist(): Promise<void> {
    //     if (this._persisted) {
    //         return;
    //     }
    //     await this.instancesService.createInstance(this);
    //     this._persisted = true;
    // }
    toJSON() {
        const { id, formId, isFinished, dateCreated, dateCompleted, members } = this;
        return { id, formId, isFinished, dateCreated, dateCompleted, members };
    }
    updateSignStatus() {
        const { members } = this;
        this._isFullSigned.set(members.every(({ isSigned }) => isSigned));
        this._isSigned.set(members.some(({ isSigned }) => isSigned));
    }
    onMemberAdd({ data: userId }) {
        if (this.hasMember(userId)) {
            return;
        }
        const member = this.formMembersFactory.createFormMember(this, userId);
        this.addMember(member);
    }
    onMemberRemove({ data: userId }) {
        if (!this.hasMember(userId)) {
            return;
        }
        this.quitMember(userId);
    }
    onUnsignedAll() {
        for (const member of this.members) {
            member.setUnsigned();
        }
    }
}
